import { Stack as MantineStack, StackFactory } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import type { IProps } from "./stack.types";

const Stack = componentWrapper<StackFactory, IProps>("Stack", (props, ref) => {
    return <MantineStack ref={ref} {...props} />;
});

export { Stack };
